import { Icons } from '../../../../icons/Icons';

export interface MessageSystemAvatarComponentProps { }

export const MessageSystemAvatarComponent = () => (
  <Icons.MessageSystemAvatar
    size={43}
  />
);
